import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiUrl } from '../../../shared/models/apiurl.models';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../models/api-response.model';
import { Category } from '../../constans/formsQuestions';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {


  constructor(private http: HttpClient, private apiUrl: ApiUrl, private apiService:ApiService) {

  }

  getCategoryById(categoryId: number): Observable<ApiResponse<Category[]>> {
    return this.apiService.get(`api/category/${categoryId}/`)
  }
  // Get all pages
  getCategories(): Observable<ApiResponse<Category[]>> {
    return this.apiService.get('api/category/')
  }

  create(form:any): Observable<ApiResponse<Category[]>> {
    return this.apiService.post('api/category/', form)
  }

  update(form:any, id:number): Observable<ApiResponse<Category[]>> {
    return this.apiService.put(`api/category/${id}/`, form)
  }

  delete(id:number): Observable<ApiResponse<Category[]>> {
    return this.apiService.delete(`api/category/${id}/`)
  }
}
